import React, {useState, useRef, useEffect} from 'react'
import Select, {PromptType} from '../../../../Prompt/Select/Select'
import Selector from '../../../../Selector/Selector'
import {NavigationButtons} from '../../../../Navigation/NavigationButtons/NavigatonButtons'
import styled from 'styled-components'
import CalendarField from '../../../../Calendar/CalendarField/CalendarField'
import {_L, useLocaleState} from '../../../../../context/LocaleContext'
import ErrorContainer from '../../../../ErrorContainer'

const MoveEmployee = ({move, onNext, onPrevious, setValue}) => {
  const localeState = useLocaleState()
  const {moveEmployees, activeMoveEmployeeIndex, numEmployees} = move

  const employee = moveEmployees[activeMoveEmployeeIndex]

  const parentContainer = useRef(null)

  const useValidate = ({employee}) => {
    const [errors, setErrors] = useState({employee: null, building: null})
    const [isNext, setIsNext] = useState(false)

    const onBlur = ({field}) => {}

    const validate = () => {
      const {building, employee: emName} = employee

      return {
        building:
          building.value.length > 0
            ? null
            : _L({key: 'Building is required', localeState}),
        employee:
          emName.value.length > 0
            ? null
            : _L({key: 'Employee is required', localeState})
      }
    }

    const hasErrors = () => {
      let errors = validate()
      setErrors(errors)
      setIsNext(true)
      return Object.keys(errors).some(x => errors[x])
    }

    useEffect(
      () => {
        let errors = validate()
        setErrors(errors)
      },
      [employee]
    )

    return {
      errors,
      onBlur,
      hasErrors,
      isNext,
      setIsNext
    }
  }

  const {errors, hasErrors, isNext, setIsNext} = useValidate({employee})

  const next = () => {
    if (!hasErrors()) {
      setIsNext(false)
      onNext()
    }
  }

  const onPromptChange = item => {
    setValue({item, index: activeMoveEmployeeIndex})
  }

  const onSelectStartDate = startDate => {
    setValue({
      item: {startDate: new Date(startDate)},
      index: activeMoveEmployeeIndex
    })
  }
  
  let currentIndex = activeMoveEmployeeIndex + 1

  const employeeIndex =
    moveEmployees.length > 1 ? '#' + currentIndex + '/' + numEmployees : ''

  return (
    <Container ref={parentContainer}>
      <Selector
        state={{
          building: employee.building,
          floor: employee.floor,
          room: employee.room
        }}
        onPromptChange={onPromptChange}
        render={(selectors, onChange) => (
          <StyledContent>
            <FieldContainer>
              <StyledTitle>
                {_L({key: 'Request Move', localeState})} {employeeIndex}
              </StyledTitle>
              <Select
                parentContainer={parentContainer}
                type={PromptType.EMPLOYEE}
                label={_L({key: 'Employee', localeState})}
                placeholder={_L({key: 'Select Employee', localeState})}
                value={employee.employee}
                selectors={selectors}
                onChange={onChange}
              />
              <ErrorContainer errorMessage={errors.employee} />
              <StyledFormLabel>
                {_L({key: 'Move date', localeState})}
              </StyledFormLabel>
              <CalendarField
                onSelect={onSelectStartDate}
                date={employee.startDate.toISOString()}
                locale="en"
              />
            </FieldContainer>

            <FieldContainer>
              <StyledTitle>{_L({key: 'Move To', localeState})}</StyledTitle>

              <Select
                parentContainer={parentContainer}
                type={PromptType.BUILDING}
                label={_L({key: 'Building', localeState})}
                placeholder={_L({key: 'Search Buildings', localeState})}
                value={employee.building}
                selectors={selectors}
                onChange={onChange}
              />
              <ErrorContainer errorMessage={errors.building} />
              <Select
                parentContainer={parentContainer}
                type={'FLOOR'}
                label={_L({key: 'Floor', localeState})}
                placeholder={_L({key: 'Search Floors', localeState})}
                value={employee.floor}
                selectors={selectors}
                onChange={onChange}
                parentFields={['blId']}
                parents={['building']}
              />
              <Select
                parentContainer={parentContainer}
                type={'ROOM'}
                label={_L({key: 'Room', localeState})}
                placeholder={_L({key: 'Search Rooms', localeState})}
                value={employee.room}
                selectors={selectors}
                onChange={onChange}
                parentFields={['blId', 'flId']}
                parents={['building', 'floor']}
              />
            </FieldContainer>
          </StyledContent>
        )}
      />

      <NavigationButtonContainer>
        <NavigationButtons onNextClick={next} onBackClick={onPrevious} />
      </NavigationButtonContainer>
    </Container>
  )
}

export default MoveEmployee

const Container = styled.div`
  width: 468px;
  position: relative;

  @media (max-width: 420px) {
    width: 100vw;
    height: calc(100vh - 80px);
    overflow-y: scroll;
    background-color: white;
    box-sizing: border-box;
  }
`

const StyledContent = styled.div`
  margin-top: 14px;
  margin-bottom: 20px;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  background-color: #ffffff;
  padding: 2px 0 34px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 420px) {
    margin: 0;
    border-radius: 0;
    width: 100vw;
    padding: 6px 0 100px 0;
  }
`

const FieldContainer = styled.div`
  padding: 34px 50px 2px 50px;
  width: 434px;

  @media (max-width: 420px) {
    width: 100%;
    padding: 18px 24px 8px 24px;
    box-sizing: border-box;
  }
`

const StyledTitle = styled.div`
  font-size: 18px;
  font-weight: normal;
  padding: 4px 0px 18px 0px;
`

const StyledFormLabel = styled.div`
  font-size: 16px;
  color: #a4a9b7;
  padding: 8px 0px 2px 0px;
  box-sizing: border-box;
  user-select: none;
`

const NavigationButtonContainer = styled.div`
  @media (max-width: 420px) {
    width: 100vw;
    height: 80px;
    background-color: white;
    position: fixed;
    bottom: 0;
    padding-top: 6px;
  }
`
